export const SLIDE_DELAY = 3000;
